import type { Student } from '../types';
import { SharedTokenService, SHARED_TOKEN_PURPOSES } from './SharedTokenService';

export type StudentPhotoUploadLinkType = 'body' | 'equipment';

export interface GenerateStudentTokenResult {
  studentId: number;
  token: string;
}

export interface ResolveStudentTokenResult {
  student: Student;
}

export interface GetOrCreatePhotoUploadLinkResult {
  studentId: number;
  linkType: StudentPhotoUploadLinkType;
  token: string;
  expiresAt: string;
  reusedExisting: boolean;
}

class StudentTokenServiceClass {
  async generateToken(studentId: number): Promise<GenerateStudentTokenResult> {
    const data = await SharedTokenService.encode(SHARED_TOKEN_PURPOSES.STUDENT, { sid: studentId });

    return {
      studentId,
      token: data.token,
    };
  }

  async getOrCreatePhotoUploadLink(
    studentId: number,
    linkType: StudentPhotoUploadLinkType,
  ): Promise<GetOrCreatePhotoUploadLinkResult> {
    const data = await SharedTokenService.getOrCreatePhotoUploadLink(studentId, linkType);

    return {
      studentId: data.studentId,
      linkType: data.linkType,
      token: data.token,
      expiresAt: data.expiresAt,
      reusedExisting: data.reusedExisting,
    };
  }

  async resolveToken(token: string): Promise<ResolveStudentTokenResult> {
    const data = await SharedTokenService.decode(token, SHARED_TOKEN_PURPOSES.STUDENT);

    if (!data.student) {
      throw new Error('Aluna não encontrada.');
    }

    return {
      student: data.student,
    };
  }
}

export const StudentTokenService = new StudentTokenServiceClass();
